export enum FormStatusEnum {
    New = 1,
    InProcess = 2,
    CompletedNotPaid = 3,
    AwaitingApproval = 4,
    CompletedPaid = 5,
    Cancelled = 6,
    Withdrawn = 7,
    Approved = 8
}
